<script setup lang="ts">
import RadIcon from '../atoms/RadIcon.vue';

const footerLinks: Record<string, { label: string; href: string; target?: string }[]> = {
  Product: [
    { label: 'Features', href: '/features' },
    // { label: 'Pricing', href: '/pricing' },
    // { label: 'Roadmap', href: 'https://docs.radsuite.io', target: '_blank' }
  ],
  Resources: [
    // { label: 'Documentation', href: 'https://docs.radsuite.io', target: '_blank' },
    // { label: 'API Reference', href: 'https://api.radsuite.io', target: '_blank' }
  ],
  Company: [
    { label: 'About Us', href: '/about' },
    { label: 'Contact', href: 'mailto:contact@tacticstechnology.com' }
  ],
  Legal: [
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms of Service', href: '/terms' }
  ]
};
</script>

<template>
  <footer class="bg-slate-100 dark:bg-slate-950 border-t border-slate-200 dark:border-white/5 pt-20 pb-10 px-4">
    <div class="max-w-7xl mx-auto">
      <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-12 mb-16">
        <!-- Brand Column -->
        <div class="col-span-2">
          <div class="flex items-center gap-1 mb-6">
            <div class="w-8 h-8 bg-primary rounded flex items-center justify-center shadow-lg shadow-primary/20">
              <RadIcon name="Zap" :size="20" class="text-white" />
            </div>
            <div class="flex items-center">
              <img
                src="/radsuite-logo.png"
                alt="RADSuite Logo"
                class="h-5 w-auto dark:hidden"
              />
              <img
                src="/radsuite-logo-dark.png"
                alt="RADSuite Logo"
                class="h-5 w-auto hidden dark:block"
              />
              <span class="text-slate-900 dark:text-white font-bold text-xl tracking-tight">Suite</span>
            </div>
          </div>
          <p class="text-slate-600 dark:text-slate-400 max-w-xs mb-8 leading-relaxed">
            The OS for the Agentic Era. Building the infrastructure for a world powered by interconnected AI agents.
          </p>
          <div class="flex gap-4">
            <a href="https://x.com/radsuite" target="_blank" rel="noopener noreferrer" class="w-10 h-10 rounded-lg bg-slate-200 dark:bg-slate-900 border border-slate-300 dark:border-white/5 flex items-center justify-center text-slate-600 dark:text-slate-400 hover:text-primary hover:border-primary/30 transition-all">
              <RadIcon name="Twitter" :size="20" />
            </a>
            <a href="https://www.github.com/rad-suite" target="_blank" rel="noopener noreferrer" class="w-10 h-10 rounded-lg bg-slate-200 dark:bg-slate-900 border border-slate-300 dark:border-white/5 flex items-center justify-center text-slate-600 dark:text-slate-400 hover:text-primary hover:border-primary/30 transition-all">
              <RadIcon name="Github" :size="20" />
            </a>
            <a href="https://www.linkedin.com/company/radsuite" target="_blank" rel="noopener noreferrer" class="w-10 h-10 rounded-lg bg-slate-200 dark:bg-slate-900 border border-slate-300 dark:border-white/5 flex items-center justify-center text-slate-600 dark:text-slate-400 hover:text-primary hover:border-primary/30 transition-all">
              <RadIcon name="Linkedin" :size="20" />
            </a>
          </div>
        </div>

        <!-- Links Columns -->
        <div v-for="(links, category) in footerLinks" :key="category">
          <h4 class="text-slate-900 dark:text-rad-white font-bold mb-6 uppercase tracking-widest text-xs">{{ category }}</h4>
          <ul class="space-y-4">
            <li v-for="link in links" :key="link.label">
              <a
                :href="link.href"
                :target="link.target || '_self'"
                class="text-slate-600 dark:text-slate-400 hover:text-primary transition-colors text-sm"
              >
                {{ link.label }}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div class="pt-8 border-t border-slate-200 dark:border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
        <p class="text-slate-500 dark:text-slate-500 text-xs">
          © 2026 Tactics Technology LLC, a division of Bioniclogic Inc. All rights reserved.
        </p>
        <div class="flex items-center gap-2 text-xs text-slate-500 dark:text-slate-500">
          <div class="w-2 h-2 rounded-full bg-emerald-500 animate-pulse"></div>
          All Systems Operational
        </div>
      </div>
    </div>
  </footer>
</template>
